import React from "react";

const achievementsContent = [
  { title: "5", subTitle1: "years of", subTitle2: "experience" },
  { title: "25", subTitle1: "completed", subTitle2: "projects" },
  // { title: "81", subTitle1: "Happy", subTitle2: "customers" },
  { title: "51", subTitle1: "awards", subTitle2: "won" },
];

const Achievements = () => {
  return (
    <div className="row">
      {achievementsContent.map((val, i) => (
        <div className="col-6" key={i}>
          <div className="box-stats with-margin" data-aos="flip-right" data-aos-duration="1200">
            <h3 className="poppins-font position-relative">{val.title}</h3>
            <p className="open-sans-font m-0 position-relative text-uppercase">
              {val.subTitle1} <span className="d-block">{val.subTitle2}</span>
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Achievements;
